import { UpdateRequest, UserRequest } from "../../../secure/user-management/scripts/user-management.entities";
declare var $: any;

export class ContactInfoPage {
    requestUpdateBtn: JQuery<HTMLElement>;
    submitSpinner: JQuery<HTMLElement>;
    errorMessageAll: JQuery<HTMLElement>;
    originalValues: any = {};
    user: UserRequest;
    constructor(user: any) {
        this.user = user;
        $(() => {
            this.originalValues = user;
            this.requestUpdateBtn = $("#request-update-btn");
            this.submitSpinner = $("#submit-spinner");      
            this.errorMessageAll = $("#all-error-message");
            this.initializeListeners();
        })
    }

    initializeListeners(): void {
        this.requestUpdateBtn.on("click", async (e) => {
            e.preventDefault();
            this.requestUpdateBtn.addClass("d-none");
            this.submitSpinner.removeClass("d-none");
            $("#request-update").addClass("ui-blocked");
            let isValid = this.verifyForm();
            if (isValid) {
                try {
                    let accountRequest: UpdateRequest = this.createRequest();
                    if (accountRequest != null) {
                        const result = await this.requestContactUpdate(accountRequest);
                        await this.showStatusMessage(result.message);
                    }

                }
                finally {
                    $("#request-update").removeClass("ui-blocked");
                    this.requestUpdateBtn.removeClass("d-none");
                    this.submitSpinner.addClass("d-none");
                }
            } else {
                $("#request-update").removeClass("ui-blocked");
                this.requestUpdateBtn.removeClass("d-none");
                this.submitSpinner.addClass("d-none");
            }
        })
    }

    async showStatusMessage(message: string) {
        const html = await $.ajax({
            url: `/auth/pages/profile/update_contact_info?handler=StatusMessage`,
            method: "GET",
            data: { message }
        });

        $("#status-message-container").html(html);
    }

    async requestContactUpdate(data: any): Promise<any> {
        try {
            const result = await $.ajax({
                url: `/auth/pages/profile/update_contact_info?handler=RequestContactUpdate`,
                method: "POST",
                headers: { "RequestVerificationToken": $('input[name="__RequestVerificationToken"]').val() },
                data: {
                    data: JSON.stringify(data),
                }
            });
            return result;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }
       
    private verifyForm(): boolean {
        let isValid = true;
        const form = $("#request-update");
        const email = form.find(".email-input").val() as string;
        const firstName = form.find("[name='Input.FirstName']").val() as string;
        const lastName = form.find("[name='Input.LastName']").val() as string;
        const organization = form.find("[name='Input.Organization']").val() as string;


        form.find(".text-danger").addClass("d-none");

        if (!email || email.trim() === "" || email.includes(" ") || !email.includes("@")) {
            isValid = false;
            form.find(".email-input")
                .siblings(".text-danger")
                .removeClass("d-none");
        }

        if (!firstName || firstName.trim() === "") {
            isValid = false;
            form.find("[name='Input.FirstName']")
                .siblings(".text-danger")
                .removeClass("d-none");
        }

        if (!lastName || lastName.trim() === "") {
            isValid = false;
            form.find("[name='Input.LastName']")
                .siblings(".text-danger")
                .removeClass("d-none");
        }

        if (!organization || organization.trim() === "") {
            isValid = false;
            form.find("[name='Input.Organization']")
                .siblings(".text-danger")
                .removeClass("d-none");
        }

        return isValid;
    }



    private createRequest(): UpdateRequest | null {
        const requestJson: any = {};
        const email = ($("#Input_Email").val() as string)?.trim();
        if (email && email !== this.originalValues.Email) {
            requestJson.Email = email;
        }

        const firstName = ($("#Input_FirstName").val() as string)?.trim();
        if (firstName && firstName !== this.originalValues.FirstName) {
            requestJson.FirstName = firstName;
        }

        const lastName = ($("#Input_LastName").val() as string)?.trim();
        if (lastName && lastName !== this.originalValues.LastName) {
            requestJson.LastName = lastName;
        }

        const org = ($("#Input_Organization").val() as string)?.trim();
        if (org && org !== this.originalValues.Organization) {
            requestJson.Organization = org;
        }

        const role = ($("#Input_TlcRole").val() as string)?.trim();
        if (role && role !== this.originalValues.TlcRole) {
            requestJson.TLCRole = role;
        }
        if (Object.keys(requestJson).length === 0) {
            this.errorMessageAll = $("#all-error-message");
            this.errorMessageAll.text("No changes were made. Please update at least one field.");
            this.errorMessageAll.removeClass("d-none");
            return null;
        }

        let newRequest = new UpdateRequest();
        newRequest.Email = this.user.Email,
        newRequest.FirstName = this.user.FirstName,
        newRequest.LastName = this.user.LastName,
        // 1 is pending 2 is approved 3 is denies
        newRequest.StatusId = 1,
        // 1 is for contatct info 2 is for trial access
        newRequest.TypeId = 1,
        newRequest.RequestJson = Object.keys(requestJson).length > 0 ? JSON.stringify(requestJson) : null


       
        return newRequest;
    }



   
}